__turbopack_context__.v({
  "card": "bracketInfo-module-scss-module__53iKEG__card",
  "cards": "bracketInfo-module-scss-module__53iKEG__cards",
  "explanation": "bracketInfo-module-scss-module__53iKEG__explanation",
  "factor": "bracketInfo-module-scss-module__53iKEG__factor",
  "factorIcon": "bracketInfo-module-scss-module__53iKEG__factorIcon",
  "factorList": "bracketInfo-module-scss-module__53iKEG__factorList",
  "factors": "bracketInfo-module-scss-module__53iKEG__factors",
  "label": "bracketInfo-module-scss-module__53iKEG__label",
  "links": "bracketInfo-module-scss-module__53iKEG__links",
  "namePlaceholder": "bracketInfo-module-scss-module__53iKEG__namePlaceholder",
  "notLegal": "bracketInfo-module-scss-module__53iKEG__notLegal",
  "note": "bracketInfo-module-scss-module__53iKEG__note",
  "panel": "bracketInfo-module-scss-module__53iKEG__panel",
  "pending": "bracketInfo-module-scss-module__53iKEG__pending",
  "placeholders": "bracketInfo-module-scss-module__53iKEG__placeholders",
  "section": "bracketInfo-module-scss-module__53iKEG__section",
  "settled": "bracketInfo-module-scss-module__53iKEG__settled",
  "tag": "bracketInfo-module-scss-module__53iKEG__tag",
  "tagDescription": "bracketInfo-module-scss-module__53iKEG__tagDescription",
  "tagName": "bracketInfo-module-scss-module__53iKEG__tagName",
  "tagRange": "bracketInfo-module-scss-module__53iKEG__tagRange",
  "tagValue": "bracketInfo-module-scss-module__53iKEG__tagValue",
});
